import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import z from 'zod';

import { getEnrollmentsDefaultParams } from '@/features/manage-enrollments/actions/getEnrollments';
import { ManageEnrollmentsListRoot } from '@/features/manage-enrollments/components/enrollments/ManageEnrollmentsListRoot';
import { getEnrollmentsQueryOptions } from '@/features/manage-enrollments/queries/getEnrollments';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { AppPageHeader } from '@/features/shared/components/AppPageHeader';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

const enrollmentsSearchParams = z.object({
  search: fallback(z.string(), '').default(''),
  page: fallback(z.number(), 0).default(0),
  perPage: fallback(
    z.number(),
    parseInt(getEnrollmentsDefaultParams.limit)
  ).default(parseInt(getEnrollmentsDefaultParams.limit)),
  sort: fallback(z.string(), getEnrollmentsDefaultParams.sort).default(
    getEnrollmentsDefaultParams.sort
  ),
  orderBy: fallback(z.string(), getEnrollmentsDefaultParams.orderBy).default(
    getEnrollmentsDefaultParams.orderBy
  ),
});

export const Route = createFileRoute(
  '/_app/app/admin-section/manage-enrollments/'
)({
  component: RouteComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  validateSearch: zodValidator(enrollmentsSearchParams),
  loaderDeps: ({ search }) => ({
    search,
  }),
  loader: async ({ context, deps }) => {
    const { search } = deps;
    await context.queryClient.prefetchQuery(
      getEnrollmentsQueryOptions({
        offset: String(search.page * search.perPage),
        limit: String(search.perPage),
        sort: search.sort,
        orderBy: search.orderBy,
        search: search.search,
        filter: getEnrollmentsDefaultParams.filter,
      })
    );
  },
  ssr: false,
});

function RouteComponent() {
  return (
    <AppPageContent className="overflow-hidden h-[calc(100%-16px)] flex flex-col">
      <AppPageHeader
        breadcrumbItems={[
          {
            label: 'App',
            link: { to: '/app' },
          },
          {
            label: 'Administration',
            link: { to: '/app' },
          },
          {
            label: 'Manage Enrollments',
            link: { to: '/app/admin-section/manage-enrollments' },
          },
        ]}
      />
      <ManageEnrollmentsListRoot />
    </AppPageContent>
  );
}
